




















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { Const } from '@/const';
import { Data } from "@/data/data";
import { DebugHelper } from "@/helper/debugHelper";
import { ResourceHelper } from "@/helper/resourceHelper";
import { CookieHelper } from "@/helper/cookieHelper"
import { JsonHelper } from "@/helper/jsonHelper";
import { EncryptionHelper } from "@/helper/encryptionHelper"
import { RequestHelper } from "@/helper/requestHelper";
import { SnsHelper } from "@/helper/snsHelper";
import { UserAgentHelper } from "@/helper/userAgentHelper";
import { NativeHelper } from "@/helper/nativeHelper";
import { CloudHelper } from "@/helper/cloudHelper";

import Header from "@/commonComponents/header/header.vue";

import LoadingScreen from "@/commonComponents/loadingScreen/loadingScreen.vue"
import License from "../top2/mainContents/license/license.vue";

import SelectSnsModal from "./selectSnsModal/selectSnsModal.vue";
import SelectPeriodModal from "./selectPeriodModal/selectPeriodModal.vue";
import SelectContentsModal from "./selectContentsModal/selectContentsModal.vue";
import RegetModal from "./regetModal/regetModal.vue";
import SignInAlertModal from "./signInAlertModal/signInAlertModal.vue";
import TimeoutModal from "../cloud/cloudModal/timeoutModal.vue";
import DeletedAccountModal from "../cloud/cloudModal/deletedAccountModal.vue";

import { CloudAccount } from "@/cloudAccount/cloudAccount";
import { Document } from '@/model/document2/document';
import { InsertionData } from '@/model/document2/insertionData/insertionData';
import { Page } from '@/model/document2/page/page';
import { Design } from '@/model/document2/page/surface/design/design';
import { FileHelper } from '../../helper/fileHelper';
import { getTemplateContent } from '../../services/getTemplateContent';
import { LogHelper } from "@/helper/logHelper";

@Component({
    components: {
        Header,
        LoadingScreen,
        SelectSnsModal,
        SelectPeriodModal,
        SelectContentsModal,
        RegetModal,
        SignInAlertModal,
        TimeoutModal,
        DeletedAccountModal,
        License
    }
})
export default class Sns extends Vue {

    loading = false;
    isLicense = false;
    isSelectSnsModalVisible = false;
    isSelectPeriodModalVisible = false;
    isSelectContentsModalVisible = false;
    isRegetModalVisible = false;
    timeoutModalShow = false;
    isDeletedAccountModal = false;
    isSns = true;
    title = "";
    message = "";
    snsType = 1;
    applyInfo = {};
    isSignInAlert = false;

    private isWaiting = false;
    private get waitingTitle() { return "処理中"; }
    private get waitingMessage() { return "処理をしています…"; }

    @Watch("cloudAccount.isSignIn")
        changeIsSignIn(){
            if(!this.cloudAccount.isSignIn && this.cloudAccount.signOutType == 2 && !this.isDeletedAccountModal){
                this.timeoutModalShow = true;
                this.cloudAccount.signOutType = 3;
            }
        }

    public get cloudAccount() : CloudAccount
    {
      	return this.$store.getters.cloudAccount;
    }

    private mounted(){
        this.cloudAccount.toGo = "Sns";

        this.$nextTick(() => {
            if(this.cloudAccount.isSignIn){
                CloudHelper.checkAccessToken((checkRes) => {
                    if(checkRes){
                        if(checkRes == "timeout"){
                            this.timeoutModalShow = true;
                            this.cloudAccount.isSignIn = false;
                            this.cloudAccount.signOutType = 3;
                        }
                        else if(checkRes == "deletedAccount"){
                            // アカウントが消えているモーダルを出す
                            this.isDeletedAccountModal = true;
                            this.cloudAccount.isSignIn = false;
                            this.cloudAccount.signOutType = 1;
                        }
                        DebugHelper.trace(checkRes);
                        return;
                    }
                    this.isSelectSnsModalVisible = true;
                });
            }
            else{
                this.isSignInAlert = true;
            }
        })

        window.addEventListener("message", this.messageEvent);

        // メッセージセンター登録
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.subscribe(this, "exec_command", this.processExecCommand);
    }

    private destroyed(){
        window.removeEventListener("message", this.messageEvent);

        // メッセージセンター削除
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.unsubscribe(this, "exec_command");

    }

    private messageEvent(message)
    {
        DebugHelper.trace("messageEvent");

        try
        {
            var jsonData = JSON.parse(message.data);

            if(jsonData.onDoCommand == "decisionSelect")
            {
                this.isWaiting = true;
                var value = jsonData.value;
                var userName = jsonData.userName;
                var userIcon = jsonData.userIcon;
                var snsType = jsonData.snsType; // 1: twitter, 2: facebook
                var applyInfo = this.applyInfo;

                DebugHelper.trace("value: ");
                DebugHelper.trace(value);
                DebugHelper.trace("userName: " + userName);
                DebugHelper.trace("userIcon: " + userIcon);
                DebugHelper.trace("snsType: " + snsType);
                DebugHelper.trace("applyInfo: ");
                DebugHelper.trace(applyInfo);

                this.applySnsContentsToDesign(value, userName, userIcon, snsType, applyInfo);
            }
            else if(jsonData.onDoCommand == "returnTemplate")
            {
                this.$router.push("/SelectTemplate");
            }
            else if(jsonData.onDoCommand == "signInCompleted")
            {
                this.isSelectPeriodModalVisible = true;
            }
            else if(jsonData.onDoCommand == "reGet"){
                this.message = jsonData.message;
                this.title = jsonData.title;
                this.isRegetModalVisible = true;
            }
            else if(jsonData.onDoCommand == "redirect"){
                this.redirect(jsonData);
            }
            else if(jsonData.onDoCommand == "request_facebook_login")
            {
                // Facebook login
                NativeHelper.sendNativeEvent("request_facebook_login", { appId : jsonData.appId });
            }
            else if(jsonData.onDoCommand == "getTimelineComp"){
                this.isSelectContentsModalVisible = true;
            }
            else if(jsonData.onDoCommand == "activeEvent"){
                CloudHelper.cloudSignOutTimer(this.cloudAccount);
            }
        }
        catch(e)
        {
            DebugHelper.trace(e);
        }
    }

    // コマンド処理
    // DL版で呼び出す
    private processExecCommand(parameterParent : any)
    {
        try
        {
            var command : string = parameterParent.command;
            var parameter : any = parameterParent.parameter;

            if(command == "facebook_login_completed")
            {
                // iframeに情報を送る
                var param = {
                    onDoCommand : "complete_facebook_login",
                };
                var ifrm = (<any>this.$refs.iframe).contentWindow;
                ifrm.postMessage(JSON.stringify(param), "*");
                // Facebook ログイン完了
                this.isSelectPeriodModalVisible = true;
            }
        }
        catch(e){}
    }

    // デザインにSNSのデータを反映させる
    private applySnsContentsToDesign(contents : any, userName : string, userIcon : string, snsType : number, applyInfo : { [key : string] : boolean })
    {
        // テンプレートIDの決定
        var templateId = this.getTemplateId(snsType);
        getTemplateContent(templateId).then(data => {
            try
            {
                // ドキュメントを作成する
                var templateDoc = FileHelper.loadDocumentAnyway(data.content);
                if(templateDoc == null)
                {
                    this.isWaiting = false;
                    return;
                }
                var currentDocument = this.$store.getters.document;
                // 反映
                SnsHelper.applyContents(contents, userName, userIcon, currentDocument, templateDoc, applyInfo, () =>
                {
                    // 完了処理
                    let rootData = this.$store.getters.data;
                    var logValue = {
                        productId : rootData.selectedProduct.id,
                        code : rootData.selectedPaper.code,
                        templateId : rootData.selectedTemplate.id,
                        templateCategoryId : rootData.selectedTemplateCategory.id,
                        hierarchy : 0
                    };
                    LogHelper.sendLog("300" , logValue);
                    this.$router.push("/DesignEditor");
                });
            }
            catch(e)
            {
                this.isWaiting = false;
                DebugHelper.trace(e);
            }
        }).catch(reason => {
            this.isWaiting = false;
            DebugHelper.trace(reason);
        });
    }

    private getTemplateId(snsType : number)
    {
        var id = id = Const.TEMPLATE_ID_FACEBOOK;
        if(snsType == 1) { id = Const.TEMPLATE_ID_TWITTER; }
        else if(snsType == 2) { id = Const.TEMPLATE_ID_FACEBOOK; }
        return id;
    }

    private onDoCommand(command: string, param, any){
        if(command == "decision"){
            this.decision(param);
        }
        else if(command == "reacquire"){
            this.reacquire();
        }
        else if(command == "selectSns"){
            this.selectSns(param);
        }
        else if(command == "selectContentsCancel"){
            this.isSelectPeriodModalVisible = true;
        }
        else if(command == "selectContents"){
            this.applyInfo = param;
        }
    }

    private loadIframe(){
        var setColorCommand = {
            onDoCommand : "setColor",
            buttonColor : this.userConfigColor,
            backgroundColor : this.$store.getters.userConfigColors.backgroundColor
        };

        var ifrm = (<any>this.$refs.iframe).contentWindow;
        ifrm.postMessage(JSON.stringify(setColorCommand), "*");
    }

    private selectSns(snsType){
        DebugHelper.trace("snsType");
        DebugHelper.trace(snsType);
        this.snsType = snsType;

        var ifrm = (<any>this.$refs.iframe).contentWindow;

        if(process.env.VUE_APP_POP_UP_AVOIDANCE === 'yes' && !UserAgentHelper.isElectron()){
            ifrm.setSnsType(snsType);
        }
        else{
            var setSnsTypeCommand = {
                onDoCommand : "setSnsType",
                value : snsType
            };
            ifrm.postMessage(JSON.stringify(setSnsTypeCommand), "*");
        }
    }

    private goSignIn(){
        this.$router.push("/SignIn");
    }

    private get iframeURL(){
        var url = Const.IFRAME_URL_BASE + "sns/index.html";
        return url;
    }

    private decision(selectPeriod: number){
        var command = "{ \"onDoCommand\" : \"selectPeriod\" , \"value\" : \"" + selectPeriod + "\" }"
        var ifrm = (<any>this.$refs.iframe).contentWindow;
        ifrm.postMessage(command, "*");
    }

    private redirect(messageJsonData){
        var ifrm = (<any>this.$refs.iframe).contentWindow;
        ifrm.postMessage(JSON.stringify(messageJsonData), "*");
    }

    private reacquire()
    {
        this.isRegetModalVisible = false;
        this.isSelectPeriodModalVisible = true;
    }

    private get currentTab() { return "/SelectTemplate"; }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigButtonColor(){
        var style = {
            backgroundColor: this.userConfigColor
        };
        return style;
    }

    private get userConfigBackgroundColor(){
        var style = {
            background: this.$store.getters.userConfigColors.backgroundColor
        };
        return style;
    }

    private toJson(content : { [ key : string ] : string | number | null | undefined | {[ key : string ] : string | number | null | undefined}})
    {
        var json = "{";
        for(var key in content)
        {
            json += '"' + key + '" : "' + content[key] + '"';
            json += ",";
        }

        json = json.substr(0, json.length - 1);
        json += "}";
        return json;
    }
}
